module.exports = __webpack_public_path__ + "img/3.1.067c0967.jpg";